module.exports = __webpack_public_path__ + "static/seo-2543d36f391944ab82170bcdb8085a19.png";